/* eslint-disable eqeqeq,no-param-reassign,@typescript-eslint/no-unused-vars,no-useless-concat */

xplenty.directive('checkbox', [
  '$timeout',

  function ($timeout) {
    return {
      restrict: 'E',

      template:
        '<label class="checkbox"><i class="fa" ng-class="{' +
        "'fa-square-o'" +
        ':!isChecked(), ' +
        "'fa-check-square'" +
        ':isChecked() }"></i> <input type="checkbox" ng-model="value" ng-true-value="\'{{trueValue}}\'" ng-false-value="\'{{falseValue}}\'" /> <span>{{text}}</span></label>',

      replace: true,

      scope: {
        value: '=ngModel',
        trueValue: '@',
        falseValue: '@',
      },

      link(scope, element, attrs) {
        if (attrs.name) {
          const $checkbox = element.find('input');
          $checkbox.attr('name', attrs.name);
        }

        scope.text = attrs.labelText;
      },

      controller: [
        '$scope',
        '$rootScope',
        '$location',
        '$sce',

        function ($scope, $rootScope, $location, $sce) {
          $scope.trueValue = $scope.trueValue || true;
          $scope.falseValue = $scope.falseValue || false;

          $scope.isChecked = function () {
            return $scope.value == $scope.trueValue;
          };
        },
      ],
    };
  },
]);
